import React from 'react';
import { sendMessageToMobile } from '@utils/mobile';
import { isMobileApp } from '@utils/environment';
import HyperLink, {
  IHyperLinkProps,
} from '@monofront/design-system/components/HyperLink';
import Link from 'next/link';

interface IWebviewLinkProps extends IHyperLinkProps {
  href: string;
  mobileMessage: {
    type: string;
    parameters: Record<string, any>;
  };
}

const WebviewLink: React.FC<IWebviewLinkProps> = ({
  children,
  href,
  mobileMessage,
  variant = 'no-style',
  className,
  size,
  hasMinWidth,
  disabled,
}) => {
  const onClick = () => {
    if (isMobileApp) {
      sendMessageToMobile(mobileMessage.type, mobileMessage.parameters);
    }
  };

  const computedHref = isMobileApp ? '#0' : href;

  return (
    <Link href={computedHref} passHref legacyBehavior>
      <HyperLink
        variant={variant}
        href={computedHref}
        onClick={onClick}
        dataTestId={`WebviewLink-go-to-${
          isMobileApp ? 'mobile-app-link' : href
        }`}
        className={className}
        size={size}
        hasMinWidth={hasMinWidth}
        disabled={disabled}
      >
        {children}
      </HyperLink>
    </Link>
  );
};

export default WebviewLink;
